var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusIcGreyTick = function SvgStatusIcGreyTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#AEB5C0",
    rx: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "7.164 11.107 5.75 12.521 10.551 17.322 18.246 7.428 16.668 6.2 10.363 14.306"
  }))));
};
export default SvgStatusIcGreyTick;